import {Component, EventEmitter, Input, Output} from '@angular/core';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';
import {CustomerClientRequest} from '../../../../domain/data/customer-client-request.data';
import {ContactEvent, CustomerClientResponse} from '../../../../domain/data/customer-client-response.data';
import {CommonModule} from '@angular/common';
import {CheckboxIconComponent} from '../../../../shared/components/checkbox-icon/checkbox-icon.component';
import {ConsentStatus} from '../../../../domain/data/consent-status';

type ContactEventsKeys = keyof Pick<CustomerClientRequest, 'events' | 'offers' | 'surveys' | 'reminder'>;

@Component({
    selector: 'app-contact-events',
    templateUrl: './contact-events.component.html',
    imports: [
        CommonModule,
        CheckboxIconComponent,
    ]
})
export class ContactEventsComponent {
  @Input() customerConsentRequest: CustomerClientRequest;
  @Input() customerConsentResponse: CustomerClientResponse;
  @Input() brand: VehicleBrand
  @Output() didChange = new EventEmitter<void>();

  private eventNameMapping: Record<string, ContactEventsKeys> = {
    EVENTS: 'events',
    OFFERS: 'offers',
    SURVEYS: 'surveys',
    REMINDER: 'reminder'
  };

  protected readonly ConsentStatus = ConsentStatus;

  get filteredContactEvents() {
    return this.customerConsentResponse?.contactEventList?.filter(event =>
      event.eventName !== 'DATA_SHARING' &&
      event.eventName !== 'PROFILING'
    ) || [];
  }

  getContactEventIcon(contactEvent: ContactEvent, icon: 'checked' | 'unchecked') {
    const mappedEventName = this.eventNameMapping[contactEvent.eventName];
    if (!mappedEventName) return 'small-box-unchecked-grey';

    const eventValue = this.customerConsentRequest[mappedEventName];
    const iconMappings = {
      checked: {
        condition: eventValue === ConsentStatus.CONFIRMED,
        true: 'small-box-checked-green',
        false: 'small-box-checked-grey'
      },
      unchecked: {
        condition: eventValue === ConsentStatus.WITHDRAWN,
        true: 'small-box-unchecked-red',
        false: 'small-box-unchecked-grey'
      }
    };
    const mapping = iconMappings[icon];
    return mapping ? (mapping.condition ? mapping.true : mapping.false) : undefined;
  }

  change(contactEvent: ContactEvent, value: ConsentStatus) {
    const mappedEventName = this.eventNameMapping[contactEvent.eventName];
    if (!mappedEventName) return;

    this.customerConsentRequest[mappedEventName] = value;
    this.didChange.emit();
  }
}
